import { render, staticRenderFns } from "./CycleLanguageSwitchSitecore.vue?vue&type=template&id=3b6efe24"
import script from "./CycleLanguageSwitchSitecore.vue?vue&type=script&lang=js"
export * from "./CycleLanguageSwitchSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports